import { InfoIcon, Input } from '@vwfs-bronson/bronson-react';
import { FieldInputProps } from 'formik';
import { t } from 'i18next';
import React, { FunctionComponent } from 'react';
import { FormField } from '..';
import { FormFieldPropsBase } from './fieldset.model';

export interface SearchTextInputFormFieldProps extends FormFieldPropsBase {
  mask?: Array<string | RegExp> | ((value: string) => Array<string | RegExp>);
  maskedValueToFormValue?: (value: string) => string;
  handleSearch: () => void;
}

export const SearchableTextInputFormField: FunctionComponent<SearchTextInputFormFieldProps> = ({
  labelTranslationKey = '',
  placeholderTranslationKey = '',
  fieldName,
  isDisabled,
  isReadonly,
  optional,
  testId,
  validateOnChange,
  infoIconTranslationKey,
  onBlur,
  handleSearch,
}): React.JSX.Element => {
  return (
    <FormField
      type="input"
      name={fieldName}
      testId={testId ?? fieldName}
      labelText={`${t(labelTranslationKey)}${optional ? t('formControls:optionalLabelAffix') : ''}`}
      validateOnChange={validateOnChange}
      isDisabled={isDisabled}
      infoIcon={infoIconTranslationKey ? <InfoIcon icon="semantic-info">{t(infoIconTranslationKey)}</InfoIcon> : null}
      render={(fieldProps: FieldInputProps<any>) => (
        <Input
          {...fieldProps}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          placeholder={t(placeholderTranslationKey)}
          readOnly={isReadonly}
          onBlur={onBlur}
          addonIcon="semantic-search"
          addonClickHandler={handleSearch}
          addonElement="button"
        />
      )}
    />
  );
};
